module.exports = __webpack_public_path__ + "images/pro/payment-goalipay-0f391fd12e57f1e78423cfd9be76c680.png";